import { useUtilityStore } from "~/store/UtililityStore";
// https://unpkg.com/browse/language-icons@0.3.0/icons/
import uk from "@/assets/language/uk.svg";
import fr from "@/assets/language/fr.svg";
import nl from "@/assets/language/nl.svg";
import sv from "@/assets/language/sv.svg";
import de from "@/assets/language/de.svg";
import es from "@/assets/language/es.svg";
import it from "@/assets/language/it.svg";
import pt from "@/assets/language/pt.svg";
import pl from "@/assets/language/pl.svg";
import jp from "@/assets/language/ja.svg";
import ar from "@/assets/language/ar.svg";
import ro from "@/assets/language/ro.svg";

export const useUtils = () => {
  const utilityStore = useUtilityStore();
  const selectedLocale = computed(() => utilityStore.selectedLocale);
  const selectedLanguage = computed(() => utilityStore.selectedLanguage);

  const showDecimalValueInLocale = computed(() => {
    return (v) => {
      if (v) {
        try {
          return Number(v).toFixed(2).toLocaleString(selectedLocale.value);
        } catch (error) {
          return v;
        }
      }
      return "";
    };
  });

  const productTitle = computed(
    () => (name) =>
      name[selectedLanguage.value] || name["fr_BE"] || name["en_GB"] || name
  );
  const productLinkTitle = computed(
    () => (name) =>
      (name[selectedLanguage.value] || name["en_GB"] || name["fr_BE"] || name)
        .replaceAll(/[^a-zA-Z0-9]+/g, "-")
        .toLowerCase()
  );


  const productLinkTitleString = computed(
    () => (name) => name?.replaceAll(/[^a-zA-Z0-9]+/g, "-").toLowerCase()
  );
  return { showDecimalValueInLocale, productTitle, productLinkTitle, productLinkTitleString };
};

export const languageMap = {
  en: uk,
  fr: fr,
  nl: nl,
  sv: sv,
  de: de,
  es: es,
  it: it,
  pt: pt,
  pl: pl,
  jp: jp,
  ar: ar,
  ro: ro,
  pt_dsh_br: pt,
};
export const floatOrZero = (v) => {
  const f = parseFloat(v);
  return isNaN(f) ? 0 : f;
};
export let gsapInstance = null;

export const loadGsap = async () => {
  if (!gsapInstance) {
    gsapInstance = await import("gsap");
  }
  return gsapInstance;
};

// helper: base64 -> Uint8Array (works on client and SSR)
export const base64ToUint8Array = (b64) => {
  if (typeof Buffer !== "undefined" && typeof window === "undefined") {
    // Node/SSR path
    const buf = Buffer.from(b64, "base64");
    return new Uint8Array(buf.buffer, buf.byteOffset, buf.byteLength);
  }
  // Browser path
  const binary = atob(b64);
  const arr = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) arr[i] = binary.charCodeAt(i);
  return arr;
};

// Parse query values where they may be string or array
export const toArray = (v) => (Array.isArray(v) ? v : v != null ? [v] : []);
